import { ItemPrice } from '@kinet-open-network/client/item-prices/data-access';
import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  AdditionalServicePriceType,
  IAdditionalService,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';

export class AdditionalService
  extends BaseModel<AdditionalService, 'AdditionalService'>
  implements IAdditionalService
{
  static override readonly modelName: AbilitySubjectType = 'AdditionalService';

  name!: string;
  description!: string | null;
  unit!: string;
  rentable!: boolean;

  @Type(() => ItemPrice)
  prices!: ItemPrice[] | null;

  get activeSellPrice() {
    return this.getActivePriceAt(AdditionalServicePriceType.Sell, new Date());
  }

  get activeRentPrice() {
    return this.getActivePriceAt(AdditionalServicePriceType.Rent, new Date());
  }

  getActivePriceAt(priceType: AdditionalServicePriceType, date: Date | number) {
    return this.prices?.find(
      (price) => price.isActiveAt(date) && price.type === priceType,
    );
  }
}
